import React from 'react';
const IconMiscFire = () => {
  return (<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path fillRule="evenodd" clipRule="evenodd" d="M14.24 5.47004C14.24 3.32004 13.5 0.670044 13.5 0.670044C17.41 3.80004 20 8.61004 20 14C20 18.42 16.42 22 12 22C7.58 22 4 18.42 4 14C4 10.62 5.21 7.51004 7.23 5.11004L7.2 5.47004C7.2 7.53004 8.76 9.20004 10.83 9.20004C12.89 9.20004 14.24 7.53004 14.24 5.47004ZM8.49 15.86C8.49 17.6 9.93 19 11.71 19C14.36 19 16.51 16.85 16.51 14.2C16.51 12.81 16.31 11.45 15.92 10.16C14.9 11.53 13.07 12.38 11.3 12.74C9.54 13.1 8.49 14.24 8.49 15.86Z" fill="#666666"/>
</svg>
);
};
export default IconMiscFire;